import { render, staticRenderFns } from "./Requestsinbox.vue?vue&type=template&id=242395a2"
import script from "./Requestsinbox.vue?vue&type=script&lang=js"
export * from "./Requestsinbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports